import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-type-side" }

import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { Action } from '@/typeDefine/CommonTypes';
import { ProductTypes } from '@/typeDefine/EntityType';
import { GetProductTypesResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, ref, Ref, watch } from 'vue';
import ProductTypeSubMenuItem from './ProductTypeSubMenuItem.vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductTypeSide',
  props: {
    isSelect: { type: Boolean }
  },
  emits: ["selectProductType"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const productTypes: Ref<ProductTypes[]> = ref([])

onMounted(() => {
    requestTypes()

    watchResize()
    window.addEventListener('resize', watchResize)
})

const defaultActive: Ref<string> = ref('')
const currentSelect: Ref<string> = ref('0')

//是否折叠
const collapse: Ref<boolean> = ref(false)

const route = useRoute()

const emit = __emit


//获取页面参数
const getPageParams: Action<[string], string | null> = (paramName: string): string | null => {
    return typeof route.query[paramName] === 'string' ? route.query[paramName] : null
}

//监听窗口大小
const watchResize: Action = () => {
    const width: number = window.innerWidth

    if (width >= 1200) {
        collapse.value = false
    }

    else if (width < 1200) {
        collapse.value = true
    }
}

const requestTypes: Action = async () => {
    const response: GetProductTypesResponse = await Api.instance.getProductTypes()

    UtilMethods.showMessageToast(response, false)

    if (response.code === ResponseCode.OK) {
        productTypes.value = response.data.treeType

        if (props.isSelect) {
            defaultActive.value = getPageParams('typeId') ?? findFirstChild(productTypes.value)

            select(defaultActive.value)
        }
    }
}

//率先找到第一个子节点
const findFirstChild: Action<[ProductTypes[]], string> = (productTypes: ProductTypes[]) => {
    for (const child of productTypes) {
        if (child.children.length === 0) {
            return child.id + ''
        }

        return findFirstChild(child.children)
    }

    return ''
}

const select: Action<[string]> = (sel: string) => {

    if (currentSelect.value === sel) {
        return
    }

    currentSelect.value = sel
    emit('selectProductType', sel)
}

__expose<{
    requestTypes: Action
}>({
    requestTypes
})

return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "active-text-color": "#FBBA0E",
      "background-color": "#F2F2F2",
      class: "el-menu-vertical-demo",
      "default-active": defaultActive.value,
      "text-color": "#333",
      onSelect: select,
      collapse: collapse.value
    }, {
      default: _withCtx(() => [
        _createVNode(ProductTypeSubMenuItem, {
          items: productTypes.value,
          collapse: collapse.value
        }, null, 8, ["items", "collapse"])
      ]),
      _: 1
    }, 8, ["default-active", "collapse"])
  ]))
}
}

})